<div mat-dialog-title>
  <div class="d-flex justify-content-between">
    Common Cart
    <i class="fa fa-times-circle pull-right" aria-hidden="true" (click)="closeDialog(null)"></i>
  </div>
</div>

<div mat-dialog-content>
  <div class="nav-container-1 m-0">
    <div class="row reset-row">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 tab-container">
        <mat-tab-group (selectedTabChange)="tabClick($event)" [(selectedIndex)]="selectedRootIndex">
          <mat-tab label="Employees">
            <ng-template mat-tab-label id="lblChallanList">
              Employees
            </ng-template>
          </mat-tab>
          <mat-tab label="Distribution List">
            <ng-template mat-tab-label id="lblChallanList">
              Distribution List <i class="eip-ml-5 ff-3 eip-link fa fa-plus-circle" title="Add"
                (click)="AddMGList()"></i>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 pagination-container">
        <div class="d-flex justify-content-end align-items-center auto-complete-equal">
          <span class="eip-mr-15">Business Group:</span>
          <EIPAutoComplete ShowTextValueField='N' WaterMarkText="Business Group" class="business-group"
            TextField="group_Name" ValueField="group_Id" floatLabelOption="never"
            [defaultValue]="projectBusinessGroupId" [dataSource]='projectBusinessGroupList' setId="ddDiscpId"
            (valueChange)='changeProjectBusinessGroup($event)' [IsCascading]='true'>
          </EIPAutoComplete>
        </div>

      </div>
    </div>

  </div>
  <div class="eip-pxy-20" *ngIf="employeeTab">
    <EIPGeneralCart [CartParameters]="cartRequest" (OnCartSubmit)='getSelectedCartItems($event)'
      (OnClick)='setCartParams()'>
    </EIPGeneralCart>
  </div>
  <div class="eip-pxy-20" *ngIf="distTab">
    <app-distribution-list [(addTabVal)]="addTabVal" (addTabValChange)="addTabVal=$event" [receiverType]="receiverType"
      [selectedList]="selectedList" selectedGroupId="projectBusinessGroupId" (postGroup)="postMessageGroup($event)">
    </app-distribution-list>
  </div>
</div>